import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";


export const postReshare = createAsyncThunk("postReshare", async ({ postId }) => {
  const response = await axiosInstance.post(`/post/repost/${postId}/`, {});
  try {
    const result = response.data;
    return result;
  } catch (error) {
    return error;
  }
});

export const getReshare = createAsyncThunk("getReshare", async ({ nextUrl, isLoadMore = false } = {}) => {
  try {
    let response;
    if (nextUrl) {
      const url = new URL(nextUrl);
      const pathAndQuery = url.pathname + url.search;
      const relativePath = pathAndQuery.replace('/api', '');
      response = await axiosInstance.get(relativePath);
    } else {
      response = await axiosInstance.get(`/post/reposts/`);
    }
    return { data: response.data, isLoadMore };
  } catch (error) {
    throw error;
  }
});

export const getOtherUserReshare = createAsyncThunk("getOtherUserReshare", async ({ userId, next, isLoadMore = false }) => {

  try {
    let response
    if (next) {
      const url = new URL(next);
      const pathAndQuery = url.pathname + url.search;
      const relativePath = pathAndQuery.replace('/api', '');
      response = await axiosInstance.get(relativePath);
    }
    else {
      response = await axiosInstance.get(`/post/repost/user/${userId}/?page=1`);
    }
    const result = response.data;
    return { data: result, isLoadMore };
  } catch (error) {
    return error;
  }
});



export const ReSharedSlice = createSlice({
  name: "ReSharedSlice",
  initialState: {
    reSharedList: [],
    loading: false,
    loadingMore: false,
    nextPage: null,
    error: null,
    hasMore: true,
    totalCount: 0,
  },
  reducers: {
    resetLoadingMore: (state) => {
      state.loadingMore = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postReshare.pending, (state) => {
      state.loading = true;
      state.reSharedList = [];
    });
    builder.addCase(postReshare.fulfilled, (state, action) => {
      // For postReshare, we don't update the list, just mark success
      // The list will be updated by a subsequent getReshare call
      state.loading = false;
    });
    builder.addCase(postReshare.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getReshare.pending, (state, action) => {
      const isLoadMore = action.meta.arg?.isLoadMore;
      if (isLoadMore) {
        state.loadingMore = true;
      } else {
        state.loading = true;
        state.reSharedList = [];
      }
    });
    builder.addCase(getReshare.fulfilled, (state, action) => {
      const { data, isLoadMore } = action.payload;
      state.loading = false;
      state.loadingMore = false;

      if (isLoadMore) {
        const existingReposts = Array.isArray(state.reSharedList) ? state.reSharedList : [];
        const newReposts = Array.isArray(data?.results?.reposts) ? data.results.reposts : [];
        state.reSharedList = [...existingReposts, ...newReposts];
      } else {
        state.reSharedList = Array.isArray(data?.results?.reposts) ? data.results.reposts : [];
      }

      state.nextPage = data?.next || null;
      state.hasMore = !!data?.next;
      if (!isLoadMore) {
        state.totalCount = data?.count ?? state.reSharedList.length;
      }
    });
    builder.addCase(getReshare.rejected, (state, action) => {
      state.loading = false;
      state.loadingMore = false;
      state.error = action.payload;
    });

    builder.addCase(getOtherUserReshare.pending, (state, action) => {
      const isLoadMore = action.meta.arg?.isLoadMore;
      if (isLoadMore) {
        state.loadingMore = true;
      } else {
        state.loading = true;
      }
    });
    builder.addCase(getOtherUserReshare.fulfilled, (state, action) => {
      state.loading = false;
      state.loadingMore = false;

      const { results, next } = action?.payload?.data;
      const isLoadMore = action?.payload?.isLoadMore;

      if (isLoadMore) {
        const existingReposts = Array.isArray(state.reSharedList) ? state.reSharedList : [];
        // Handle different possible data structures for reposts
        let newReposts = [];
        if (Array.isArray(results)) {
          newReposts = results;
        } else if (results?.reposts && Array.isArray(results.reposts)) {
          newReposts = results.reposts;
        } else if (results?.results && Array.isArray(results.results)) {
          newReposts = results.results;
        }
        state.reSharedList = [...existingReposts, ...newReposts];
      } else {
        // Handle different possible data structures for initial load
        if (Array.isArray(results)) {
          state.reSharedList = results;
        } else if (results?.reposts && Array.isArray(results.reposts)) {
          state.reSharedList = results.reposts;
        } else if (results?.results && Array.isArray(results.results)) {
          state.reSharedList = results.results;
        } else {
          state.reSharedList = [];
        }
      }

      state.nextPage = next;
      state.hasMore = !!next;
    });
    builder.addCase(getOtherUserReshare.rejected, (state, action) => {
      state.loading = false;
      state.loadingMore = false;
      state.error = action.payload;
    });
  },
});

export const { resetLoadingMore } = ReSharedSlice.actions;
export default ReSharedSlice.reducer;
